import { Injectable } from '@angular/core';
import { routeOverride } from '@df/core/meta/route-override.pipe';

export const NoFollowPaths = [
    new RegExp(`\/${routeOverride('/basket')}(\/.*)?`),
    routeOverride('/login'),
    routeOverride('/login/reset-password')
];

@Injectable({
    providedIn: 'root'
})
export class RelService {
    /**
     * Gets rel parameter to set on link
     * @param href
     * @returns
     */
    getRel(href?: string): string | undefined {
        const rel: string[] = [];
        if (typeof href === 'string') {
            if (NoFollowPaths.find(rule => (typeof rule === 'string' ? rule === href : rule?.test(href)))) {
                rel.push('nofollow');
            }
            if (href.includes(':')) {
                rel.push('noopener');
            }
        }
        return rel.join() || undefined;
    }
}
